import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AiOutlineRight } from "react-icons/ai";
// import Search from "antd/es/input/Search";
import {
  CheckOutlined,
  CloseOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import {
  Button,
  Col,
  message,
  Popconfirm,
  Row,Typography ,
  notification,
  Space,
  Table,
  Form,
  Tag,
  Tooltip,
  Modal,
  Switch,
  Flex, 
} from "antd";
import IMAGES from "../../const/Image";
import { useLocation } from "react-router-dom";
import Search from "antd/es/input/Search";
import { components, getRowClassName } from "../../utils/utils";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Tabs, Input } from "antd";
import DashboardRequest from "../Dashboard/DashboardRequest";

const initialFilter = { page: 1 };

function Setting() {
  //  const hasListPermission = usePermission("CustomServiceRequests", "List");
  // console.log('Has list permission:', hasListPermission);

  const [loading, setLoading] = useState(false);
  const [labList, setLabList] = useState([]);
  const { confirm } = Modal;
  const [form] = Form.useForm();
  const [totalRecords, setTotalRecords] = useState(0);
  const [filterForm, setFilterForm] = useState({});
  const [filter, setFilter] = useState(initialFilter);
  const [updatedSalons, setUpdatedSalons] = useState([]);
  const location = useLocation();
  const [submited, setSubmit] = useState(false);
  const [activeTab, setActiveTab] = useState(location.state?.tabKey || "1");
  const [activeTabUpdate, setActiveTabupdate] = useState(5);

  const navigate = useNavigate();

  const update = () => {
    setSubmit(true);
  };

  const handleTabChange = (key) => {
    setActiveTab(key);
    setFilter((prev) => ({
      ...prev,
      page: 1,
    }));
  };

  const items = [
    {
      key: "1",
      label: "Pricing",
      children: (
        <div style={{ display:"flex", gap: "20px", alignItems: "center" }}>
          <div style={{width : "50%"}}>
          <Typography.Title level={5}>Pricing Multiplier</Typography.Title>
              <Input size="large" placeholder="large size"  />
          
          </div>
          <div className="bottom-button" style={{marginTop : "2rem"}}>
              <div>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                  onClick={update}
                >
                  Save 
                  <span>
                    <AiOutlineRight />
                  </span>
                </Button>
              </div>
            </div>
        </div>
      ),
    },
    // {
    //   key: "2",
    //   label: "New Requests",
    //   children: (
    //     <div style={{}}>
    //       <Table
    //         size="middle"
    //         bordered
    //         rowClassName={getRowClassName}
    //         components={components}
    //         columns={newRequestColumns(navigate)}
    //         loading={loading}

    //         scroll={{ x: "max-content" }}
    //         onChange={handleChange}
    //         dataSource={labList || null}
    //         pagination={{
    //           total: totalRecords,
    //           current: filter?.page,
    //           pageSize: 10,
    //           showSizeChanger: false,
    //           showTotal: (total, range) =>
    //             `${range[0]}-${range[1]} of ${total} items`,
    //           onChange: (page) => setFilter((prev) => ({ ...prev, page })),
    //         }}
    //       />
    //     </div>
    //   ),
    // },
    // {
    //   key: "3",
    //   label: "Approved Requests",
    //   children: (
    //     <div style={{}}>
    //       <Table
    //         size="middle"
    //         bordered
    //         rowClassName={getRowClassName}
    //         components={components}
    //         columns={columns(navigate)}
    //         loading={loading}

    //         scroll={{ x: "max-content" }}
    //         onChange={handleChange}
    //         dataSource={labList || null}
    //         pagination={{
    //           total: totalRecords,
    //           current: filter?.page,
    //           pageSize: 10,
    //           showSizeChanger: false,
    //           showTotal: (total, range) =>
    //             `${range[0]}-${range[1]} of ${total} items`,
    //           onChange: (page) => setFilter((prev) => ({ ...prev, page })),
    //         }}
    //       />
    //     </div>
    //   ),
    // },
    // {
    //   key: "4",
    //   label: "Rejected Requests",
    //   children: (
    //     <div style={{}}>
    //       <Table
    //         size="middle"
    //         bordered
    //         rowClassName={getRowClassName}
    //         components={components}
    //         columns={columns(navigate)}
    //         loading={loading}

    //         scroll={{ x: "max-content" }}
    //         onChange={handleChange}
    //         dataSource={labList || null}
    //         pagination={{
    //           total: totalRecords,
    //           current: filter?.page,
    //           pageSize: 10,
    //           showSizeChanger: false,
    //           showTotal: (total, range) =>
    //             `${range[0]}-${range[1]} of ${total} items`,
    //           onChange: (page) => setFilter((prev) => ({ ...prev, page })),
    //         }}
    //       />
    //     </div>
    //   ),
    // },
  ];

  return (
    <>
      <div className="">
        {/* <Form.Item className="text-center submit-btn">
          <Space>
            <Button className="f-sub-btn btn-width" onClick={() => navigate(-1)} disabled={loading}>
              <ArrowLeftOutlined />
            </Button>
          </Space>
        </Form.Item> */}
        <Row gutter={[8, 8]} justify="space-between" align="middle">
          <Col>
            <h1 className="app-heading-med">Settings</h1>
          </Col>

          {/* <Col>

            <div style={{ display: "flex", gap: "1rem" }}>
              <Search
                placeholder="Search..."
                allowClear
                size="large"
                onSearch={onSearch}
                // onChange={handleSearch}
                value={filterForm?.title}
                style={{ width: "100%" }}
              />

            </div>
          </Col> */}
        </Row>
      </div>
      <div style={{ marginTop: "20px" }}>
        <Tabs
          defaultActiveKey={activeTab}
          items={items}
          onChange={handleTabChange}
        />
      </div>
    </>
  );
}

export default Setting;
